import commonEn from './locales/en/common.json';
import commonPtBR from './locales/pt-BR/common.json';
import commonEs from './locales/es/common.json';
import commonJa from './locales/ja/common.json';

export const commonTranslations = {
  en: { common: commonEn },
  'pt-BR': { common: commonPtBR },
  es: { common: commonEs },
  ja: { common: commonJa },
} as const;
